/**
 * https://github.com/FuelLabs/fuels-ts/blob/master/packages/address/src/utils.ts
 */

export default {
    isValidAddress(address, currency, opts = {}) {
        return address.length === 66 && /(0x)[0-9a-f]{64}$/i.test(address);
    },
};
